<script setup lang="ts">
import { useDrawingStore } from "@/stores/fileStore";
import { Logger } from "@/logger";
import FullscreenUploader from "../UI/FullscreenUploader.vue";

const props = defineProps<{
  projectId: number;
}>();

const drawingStore = useDrawingStore();

async function uploadFile(files?: File[]) {
  if (files) {
    Logger.info(`DrawingUploader.vue : uploading files, ${files.length}`);
    try {
      drawingStore.uploadFiles(files, props.projectId);
    } catch(e) {
      Logger.error(
        `DrawingUploader.vue : could not upload file, ${JSON.stringify(e)}`
      );
      throw e;
    }
  } else {
    Logger.info(`DrawingUploader.vue : No file upaloaded`);
  }
}
</script>

<template>
  <FullscreenUploader
    :description="$t('dashboard:plan.import.description')"
    :extensions="['dwg']"
    fullscreen
    @files="uploadFile"
  />
</template>
